const donutItemClick = (e)=>{
  console.log('donutItemClick() has fired', e)
  return false
}

const donutItemMouseOver = (e)=>{
  console.log('donutItemMouseOver() has fired', e)
  return false
}

// in use for disabling default behavior. We add custom event handlers are runtime in the component itself, as there doesn't seem to be a way to reference
// the chart instance from here (the event doesn't have a reference to the chart that can be interacted with)
const legendItemClick = (e)=>{
  // console.log('legendItemClick() has fired', e)
  // e.target.series.data[e.target.index].setState('hover')
  return false
}

const schoolColors = [
  '#e00122',
  '#000000',
  // '#ffffff',
  '#890519',
  '#a7a5aa',
  '#e0dfe3',
  '#333333',
  '#d1b179',
  '#eadbc1',

  '#007bff',
  '#fd7e14',
  '#e83e8c',
  '#28a745',
  '#20c997'
]

export let donutBaseConfig = {
  chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      height: (9 / 16 * 100) + '%', // 16:9 ratio
      style: {
        fontFamily: "\"Open Sans\", sans-serif"
    }
  },
  
  colors: schoolColors,
  
  title: null,
  tooltip: {
      pointFormat: '{point.percentage:.1f}%',
      useHTML: true,
      className: 'uc-tooltip',
      shadow: false,
      borderWidth: 0,
      backgroundColor: 'rgba(255,255,255,0)',
      shape: 'circle',
      positioner: function(labelWidth, labelHeight, point) {
        // return { x: this.chart.plotWidth/2, y: this.chart.plotHeight/2 };
        // return { x: this.chart.chartWidth/2, y: this.chart.chartHeight/2 };
        var labelWidthOffset = labelWidth/2 -6;
        var labelHeightOffset = this.chart.clipBox.height * .1;
        return { x: ((this.chart.clipBox.width/2) - labelWidthOffset), y: (this.chart.clipBox.height/2 - labelHeightOffset) };
      },
      formatter: function () {
        return '<span style="font-size: 40%; color: var(--uc-red);font-weight:normal;font-family:\"Open Sans\" sans-serif">' + this.key + '</span><br><b>' + this.y + '%</b>';
      },
      style: {
        fontSize: '72px',
        fontWeight:'900',
        fontFamily: "\"Open Sans\", sans-serif",
        textAlign: 'center',
        padding: '30px'
      }
  },
  accessibility: {
      point: {
          valueSuffix: '%'
      },
      linkedDescription: '' // This needs to be set per each implementation, for a11y purposes.
  },
  plotOptions: {
      pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
              enabled: false
          },
          showInLegend: true,
          point: {
            events: {
              legendItemClick: legendItemClick,
              // mouseOver: legendItemClick
            }
          }
          // events: {
          //   click: donutSeriesClick,
          //   mouseOver: donutSeriesClick
          // }

      },
      series: {
        events: {
          // click: donutItemClick,
          // mouseOver: donutItemMouseOver
        }
      }
  },
  series: [{
      name: 'Faculty by Race/Ethnicity',
      colorByPoint: true,
      data: [],
      innerSize: '60%'
  }],
  legend: {
    align: 'right',
    verticalAlign: 'top',
    layout: 'vertical',
    x: 0,
    y: 100,
    itemStyle: { 'fontSize': '18px' }
  },
  responsive: {
    rules: [
      {
        condition: { maxWidth: 900 },
        chartOptions: {
          tooltip: {
            style: {
              fontSize: '34px' 
            }
          },
          // chart : {
          //   height: '500'
          // }
        }
      },    
      {
        // condition: { maxWidth: 768 },
        condition: { maxWidth: 600 },
        chartOptions: {
          tooltip: {
            style: {
              fontSize: '30px' 
            }
          },
          chart : {
            height: (16 / 11 * 100) + '%'
          },
          legend: {
            align: 'center',
            verticalAlign: 'bottom',
            x: 0,
            y: 0
          }
        }
      }
    
  ]
  }
}

/**
 * Compose the donut config
 * @param {*} data 
 * @param {string} allyDesc 
 * @returns {*}
 */
export function donutConfigWithData(data, allyDesc) {
  let config = donutBaseConfig
  config.series[0].data = data
  config.accessibility.linkedDescription = allyDesc
  return config
}